export default {
    url: '/pool',
    template: '<ui-view></ui-view>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/settings/pool/index.js